import { OrderLineStatusOption } from '@/utils/constants';

export const Labels = {
  Deliver: 'orderLine.deliver',
  PickUp: 'orderLine.pickUp',
  Yes: 'common.yes',
  No: 'common.no',
  Urgent: 'orderLine.urgent'
};

export default {
  data() {
    return {
      consumerOrderTicketURL: null
    };
  },
  computed: {
    orderLineStatuses() {
      return this.$store.getters['orderLineStatus/loadedItems'].filter(
        status =>
          status.orderLineStatusOption !== OrderLineStatusOption.Shipping &&
          status.orderLineStatusOption !== OrderLineStatusOption.Invoicing
      );
    },
    productGroups() {
      return this.$store.getters['productGroup/loadedItems'];
    },
    transportStatuses() {
      return this.$store.getters['orderLineStatus/loadedItems'].filter(
        status => status.orderLineStatusOption === OrderLineStatusOption.Shipping
      );
    }
  },
  watch: {
    orderLineStatuses(orderLineStatuses) {
      const column = this.getColumn('orderLineSubstatusName');
      if (column) {
        column.filter.options = orderLineStatuses;
      }
    },
    productGroups(productGroups) {
      this.getColumn('productGroupDescription').filter.options = productGroups;
    },
    transportStatuses(transportStatuses) {
      const column = this.getColumn('transportOrderLineSubstatusName');
      if (column) {
        column.filter.options = transportStatuses;
      }
    }
  },
  created() {
    this.$store.dispatch('productGroup/getItems');
    this.$store.dispatch('orderLineStatus/getItems');
    this.$store.dispatch('store/getStoreConfiguration').then(config => {
      this.consumerOrderTicketURL = config.consumerOrderTicketURL;
    });
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    formatOrderExceedance(row, column, cellValue) {
      const option = this.$store.getters['option/loadedOptions']('orderExceedance').find(
        item => item.code === row.orderExceedance
      );
      return option && option.description;
    },
    formatDeliverAtHomeYN(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Deliver) : this.$t(Labels.PickUp);
    },
    formatOrderLineStatus(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('orderLineStatus').find(item => item.code === cellValue);
      return option && option.description;
    },
    formatUrgentYN(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Urgent) : '';
    },
    getCustomListActions() {
      return [
        {
          type: 'primary',
          icon: 'el-icon-document',
          handleClick: this.handleDocumentActionClicked,
          inRow: true
        }
      ];
    },
    async handleDocumentActionClicked(row) {
      if (row.id.startsWith('LB')) {
        if (!this.consumerOrderTicketURL) {
          this.$store.dispatch('notify/error', {
            message: this.$i18n.t('store.noConsumerOrderTicketURLConfigured')
          });
        } else {
          const url = `${this.consumerOrderTicketURL}?id=${row.customerReference}`;
          window.open(url, 'ConsumerOrderTicketWindow');
        }
      } else {
        this.loading = true;
        this.$store
          .dispatch('storeOrderLine/downloadOrderAsPDF', row.id)
          .then(data => {
            this.createObjectURL(data, row.id);
          })
          .finally(() => (this.loading = false));
      }
    },
    createObjectURL(content, id) {
      const file = this.b64toFile(content, id, 'application/pdf');
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(file);
      anchor.download = id;
      anchor.click();
    },
    b64toFile(b64Data, fileName, mediaType, sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new File(byteArrays, fileName, { type: mediaType });
    }
  }
};
